import { render, staticRenderFns } from "./scrollItem.vue?vue&type=template&id=3004eafe"
import script from "./scrollItem.vue?vue&type=script&lang=js"
export * from "./scrollItem.vue?vue&type=script&lang=js"
import style0 from "./scrollItem.vue?vue&type=style&index=0&id=3004eafe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports